import { MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
export default function CallToAction() {
  return;
}